import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import mergeClassName from '@tencent/data-schema/lib/utils/mergeClassName';
import FormContainerBase from '../../plugins/form/FormContainerBase';
let WForm = class WForm extends FormContainerBase {
  handleSubmit(ev) {
    ev.preventDefault();
  }
  handleBlur() {
    if (this.autoValidate === 'blur') this.validateDebounced();
  }
  render() {
    const h = arguments[0];
    const {
      isDesignMode,
      className
    } = this;
    return h("form", _mergeJSXProps([{
      "class": mergeClassName('w-form ', className, isDesignMode && 'isDesignMode'),
      "style": this.css
    }, {
      "on": {
        submit: this.handleSubmit,
        '!blur': this.handleBlur
      }
    }]), [h("div", {
      "class": "uc-slotForBlocks w-form-content",
      "ref": "container"
    }, [this.$slots.default || isDesignMode && h("div", {
      "style": "min-height:48px;line-height:48px;"
    }, ["\u8FD9\u662F\u4E00\u4E2A\u7A7A\u767D\u8868\u5355\uFF0C\u8BF7\u4ECE\u201C\u6570\u636E\u6E90\u201D\u4E2D\u62D6\u62FD\u4E00\u4E9B\u5B57\u6BB5\u8FDB\u6765\u3002"])])]);
  }
};
WForm = __decorate([Component({
  name: 'WForm',
  props: {
    autoValidate: {
      type: String,
      default: 'none'
    },
    className: {
      type: String,
      default: ''
    },
    css: {
      type: String,
      default: ''
    }
  }
})], WForm);
export default WForm;